import { provideWidgetClass } from 'scrivito'

export const DXPMyActivitiesWidget = provideWidgetClass(
  'DXPMyActivitiesWidget',
  {
    attributes: {},
  },
)
